// extracted by mini-css-extract-plugin
export default {"rippleContainer":"index_rippleContainer__AhDu1","rippleDot":"index_rippleDot__gGldt","rippleFadeScale":"index_rippleFadeScale__XqqWY"};